import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import CultureView from '../views/CultureView.vue'
import CompanyView from '../views/CompanyView.vue'
import ShopView from '../views/ShopView.vue'
import DevelopView from '../views/DevelopView.vue'
import WorkView from '../views/WorkView.vue'

import TalkView from '../views/TalkView.vue'
// 
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/culture',
    name: 'culture',
    // component: () => import(/* webpackChunkName: "about" */ '../views/CultureView.vue')
    component: CultureView

  },
  {
    path: '/company',
    name: 'company',
    // component: () => import(/* webpackChunkName: "about" */ '../views/companyView.vue')
    component: CompanyView

  },
  {
    path: '/shop',
    name: 'shop',
    // component: () => import(/* webpackChunkName: "about" */ '../views/companyView.vue')
    component: ShopView

  },
  {
    path: '/develop',
    name: 'develop',
    // component: () => import(/* webpackChunkName: "about" */ '../views/companyView.vue')
    component: DevelopView

  },
  {
    path: '/work',
    name: 'work',
    // component: () => import(/* webpackChunkName: "about" */ '../views/companyView.vue')
    component: WorkView

  },
  {
    path: '/talk',
    name: 'talk',
    // component: () => import(/* webpackChunkName: "about" */ '../views/companyView.vue')
    component: TalkView

  },
  
]

const router = new VueRouter({
  routes
})

export default router
